import {
  CHARCOAL_5,
  OwnUpExtraSmallHeadlineMedium,
  OwnUpThemeProvider,
  ownUpWhiteTheme,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { useDownPayment } from '../data/dataProvider';
import { Slider } from '../slider';
import { SummaryArticle } from './summary-article';
import { SummaryNumbers } from './summaryNumbers';

const Container = styled.div`
  background-color: ${({ theme }: PropsWithTheme<{}>) => theme.palette.background.default};
  filter: drop-shadow(4px 4px 8px ${CHARCOAL_5});
  border-radius: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1, 1, 0, 0)};
  padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(5, 3)};

  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
  margin-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
`;

export const CalculationSummary = () => {
  const {
    state: { showFull }
  } = useDownPayment();
  return (
    <>
      {showFull && (
        <OwnUpThemeProvider theme={ownUpWhiteTheme}>
          <OwnUpExtraSmallHeadlineMedium variant="h2">Your results</OwnUpExtraSmallHeadlineMedium>
          <Container>
            <SummaryNumbers />
            <Slider />
            <SummaryArticle />
          </Container>
        </OwnUpThemeProvider>
      )}
    </>
  );
};
